import "core-js/modules/es.array.concat.js";
import { Avatar, DescriptionList, Flex, Link, Text } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { Copyable } from "../../../../../components/Copyable";
import { SideBarDescriptionList } from "../SideBarDescriptionList";
import { LabelledFlag } from "../../LabelledFlag";
import { useApplicationRecruitmentPartner } from "../../../data/recruitmentPartner";
import { useSideBarEventTracker } from "../../../utils/eventTracking";
import { ApplicationNoticeList } from "../ApplicationNoticeList";
import { assert } from "../../../../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var RecruitmentPartnerDetails = function RecruitmentPartnerDetails(_ref) {
  var _lastName$;
  var copyEnabled = _ref.copyEnabled;
  var _useApplicationRecrui = useApplicationRecruitmentPartner(),
    recruitmentPartner = _useApplicationRecrui.recruitmentPartner;
  assert(recruitmentPartner, 'Recruitment partner not found in aggregated data');
  var trackEvent = useSideBarEventTracker();
  var _useTranslation = useTranslation('RecruitmentPartnerDetails'),
    t = _useTranslation.t;
  var agentId = recruitmentPartner.id;
  var firstName = recruitmentPartner.personalInformation.firstName;
  var lastName = recruitmentPartner.personalInformation.lastName;
  return _jsxs(Flex, {
    direction: "column",
    gap: 6,
    children: [_jsx(ApplicationNoticeList, {
      regarding: "recruitment_partner"
    }), _jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [_jsxs(Flex, {
        gap: 4,
        children: [_jsx(Avatar, {
          initials: "".concat(firstName[0]).concat((_lastName$ = lastName === null || lastName === void 0 ? void 0 : lastName[0]) !== null && _lastName$ !== void 0 ? _lastName$ : '')
        }), _jsxs(Flex, {
          direction: "column",
          children: [_jsx(Text, {
            variant: "labelL",
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: _jsx(Link, {
                href: "/agents/".concat(agentId),
                onClick: function onClick() {
                  trackEvent({
                    event: 'Recruitment Partner Details - Clicked To View Profile'
                  });
                },
                children: "".concat(firstName).concat(lastName ? " ".concat(lastName) : '')
              })
            })
          }), _jsx(Text, {
            children: _jsxs(Flex, {
              gap: 1,
              children: ["".concat(t('id')), _jsx(Copyable, {
                disabled: !copyEnabled,
                children: agentId
              })]
            })
          })]
        })]
      }), _jsx(PersonalInformationDetails, {
        copyEnabled: copyEnabled
      })]
    }), _jsx(PartnerRepresentativeDetails, {
      copyEnabled: copyEnabled
    })]
  });
};
var PersonalInformationDetails = function PersonalInformationDetails(_ref2) {
  var copyEnabled = _ref2.copyEnabled;
  var _useApplicationRecrui2 = useApplicationRecruitmentPartner(),
    recruitmentPartner = _useApplicationRecrui2.recruitmentPartner;
  assert(recruitmentPartner, 'Recruitment partner not found in aggregated data');
  var _useTranslation2 = useTranslation('RecruitmentPartnerDetails'),
    t = _useTranslation2.t;
  return _jsxs(SideBarDescriptionList, {
    children: [_jsx(DescriptionList.Term, {
      children: t('email')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Text, {
        wordBreak: "word",
        children: _jsx(Copyable, {
          disabled: !copyEnabled,
          children: recruitmentPartner.email
        })
      })
    }), _jsx(DescriptionList.Term, {
      children: t('firstName')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: recruitmentPartner.personalInformation.firstName
      })
    }), _jsx(DescriptionList.Term, {
      children: t('lastName')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: recruitmentPartner.personalInformation.lastName || '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: t('id')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: recruitmentPartner.id
      })
    }), _jsx(DescriptionList.Term, {
      children: t('phoneNumber')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: recruitmentPartner.personalInformation.phone || '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: t('company')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: recruitmentPartner.agentInformation.companyName || '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: t('country')
    }), _jsx(DescriptionList.Details, {
      children: recruitmentPartner.addressInformation.countryCode ? _jsx(LabelledFlag, {
        countryCode: recruitmentPartner.addressInformation.countryCode,
        copyEnabled: copyEnabled
      }) : '--'
    })]
  });
};
var PartnerRepresentativeDetails = function PartnerRepresentativeDetails(_ref3) {
  var copyEnabled = _ref3.copyEnabled;
  var _useApplicationRecrui3 = useApplicationRecruitmentPartner(),
    recruitmentPartner = _useApplicationRecrui3.recruitmentPartner;
  assert(recruitmentPartner, 'Recruitment partner not found in aggregated data');
  var _useTranslation3 = useTranslation('RecruitmentPartnerDetails'),
    t = _useTranslation3.t;
  return recruitmentPartner.agentManager ? _jsx(_Fragment, {
    children: _jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [_jsx(Text, {
        id: "partner-representative-heading",
        variant: "labelL",
        children: t('partnerRepresentative')
      }), _jsxs(SideBarDescriptionList, {
        "aria-labelledby": "partner-representative",
        children: [_jsx(DescriptionList.Term, {
          children: t('name')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: recruitmentPartner.agentManager.fullName ? recruitmentPartner.agentManager.fullName : '--'
          })
        }), _jsx(DescriptionList.Term, {
          children: t('email')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: _jsx(Text, {
              wordBreak: "word",
              children: recruitmentPartner.agentManager.email
            })
          })
        })]
      })]
    })
  }) : null;
};